import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getRangeValue } from '../../../packages/JsonQuery';

export const selectBeds = createSelector(selectJsonQuery, jsonQuery => getRangeValue('beds_count')(jsonQuery));
